import { useEffect } from "react";

const SITE_NAME = "蝌蚪爆料";
const BASE_URL = "https://dfjor.cn";

interface SeoProps {
  title: string;
  description: string;
  keywords?: string;
  path?: string;
  ogType?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel: string, href: string) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo({
  title,
  description,
  keywords,
  path = "/",
  ogType = "website",
  jsonLd,
}: SeoProps) {
  useEffect(() => {
    const url = `${BASE_URL}${path}`;
    document.title = title;

    upsertMeta("name", "description", description);
    if (keywords) upsertMeta("name", "keywords", keywords);
    upsertMeta("name", "robots", "index, follow");

    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", ogType);
    upsertMeta("property", "og:site_name", SITE_NAME);
    upsertMeta("property", "og:url", url);

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);

    upsertLink("canonical", url);
  }, [title, description, keywords, path, ogType]);

  useEffect(() => {
    const id = "page-structured-data";
    const previous = document.getElementById(id);
    if (previous) previous.remove();
    if (!jsonLd) return undefined;

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      const current = document.getElementById(id);
      if (current) current.remove();
    };
  }, [jsonLd]);

  return null;
}